import { render } from "./Table.vue?vue&type=template&id=6cada172&scoped=true&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=6cada172&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cada172"]])

export default __exports__